import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { OrderErpStatusNote } from "./types/OrderErpStatusNote";

const orderErpStatusNote = gql`
  query OrderErpStatusNote {
    orderErpStatusNote {
      id
      status
      note
    }
  }
`;
export const useOrderErpStatusNoteQuery = makeQuery<OrderErpStatusNote, null>(
  orderErpStatusNote
);
